import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateAddressLine,
	validateText,
	validateEmail,
	validatePhoneNumber,
	validatePostcode,
	validateUsername,
} from '../../../util/validation/commonValidation';
import type { FullOperatorDto } from '../types/OperatorDto';

export function useEditStaffMemberForm(defaultOperator: FullOperatorDto) {
	const [inputs, setInputs] = useState<FullOperatorDto>(defaultOperator);

	const form = useForm<FullOperatorDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			username: (value) => validateUsername(value),
			cardNo: (value) => validateText(value, false, 'Card number', 30),
			firstName: (value) => validateText(value, false, 'First name'),
			surname: (value) => validateText(value, false, 'Surname'),
			jobTitle: (value) => validateText(value, false, 'Job title'),
			postCode: (value) => validatePostcode(value, false),
			town: (value) => validateText(value, false, 'Town'),
			county: (value) => validateText(value, false, 'County'),
			addressLineOne: (value) => validateAddressLine(value, false),
			addressLineTwo: (value) => validateAddressLine(value, true),
			phone: (value) => validatePhoneNumber(value, false),
			email: (value) => validateEmail(value, false),
			emergencyContactName: (value) =>
				validateText(value, false, 'Emergency contact name'),
			emergencyContactNumber: (value) => validatePhoneNumber(value, false),
			branchId: (value) => {
				if (!value) {
					return 'Please select a branch';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
